import { Input } from "antd";
import styled from "styled-components";

export const KInput = styled(Input)({
  '&.ant-input:focus-within': {
    boxShadow: 'none',
  }
});
